import {UUID} from '../../../shared/types/uuid.type';
import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {catchError, concatMap, map, tap} from 'rxjs/operators';
import {forkJoin, Observable, of} from 'rxjs';
import {MatSnackBar} from '@angular/material/snack-bar';
import {startManyDestinations, startManyDestinationsFailure, startManyDestinationsSuccess} from './destination.start-many.actions';
import {DestinationsService} from '../../../services/api/destinations/destinations.service';
import {Destination} from '../../../services/api/destinations/destination.model';
import {loadDestinations, manyDestinationsStarted} from '../actions/destinations.actions';


@Injectable()
export class DestinationStartManyEffects {

  // noinspection JSUnusedGlobalSymbols
  startManyDestinations$ = createEffect(() => {
    return this.actions$
      .pipe(
        ofType(startManyDestinations),
        concatMap((payload: { ids: UUID[] }) => {
          const ids: UUID[] = payload.ids;
          const requests: Observable<Destination>[] = ids
            .map((destinationId: UUID): Observable<Destination> =>
              this.service.startDestination(destinationId)
            );

          return forkJoin(requests)
            .pipe(
              map(() => startManyDestinationsSuccess({ids})),
              catchError(error => of(startManyDestinationsFailure({error})))
            );
        }));
  });

  // noinspection JSUnusedGlobalSymbols
  startManyDestinationsSuccess$ = createEffect(() => {
    return this.actions$
      .pipe(
        ofType(startManyDestinationsSuccess),
        tap(() =>
          this.snackBar.open('Destinations successfully started', 'Success', {duration: 3000})),
        map((data: { ids: UUID[] }) => manyDestinationsStarted({ids: data.ids}))
      );
  });

  // noinspection JSUnusedGlobalSymbols
  startManyDestinationsFailure$ = createEffect(() => {
    return this.actions$
      .pipe(
        ofType(startManyDestinationsFailure),
        tap((error: { error: any }) =>
          this.snackBar.open(`Failed to start destinations: ${error.error}`, 'Error', {duration: 3000})),
        map(() => loadDestinations())
      );
  });

  constructor(
    private readonly actions$: Actions,
    private readonly service: DestinationsService,
    private readonly snackBar: MatSnackBar
  ) {
  }

}
